/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cad_Modal_SubtitleInputs */

const en_cad_modal_subtitle = /** @type {(inputs: Cad_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The customer agreed on a new appointment with you.`)
};

const ja_cad_modal_subtitle = /** @type {(inputs: Cad_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`顧客と新しい予約日に合意しました。`)
};

const fr_cad_modal_subtitle = /** @type {(inputs: Cad_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le client a convenu d'un nouveau rendez-vous avec vous.`)
};

const de_cad_modal_subtitle = /** @type {(inputs: Cad_Modal_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Kunde hat mit Ihnen einen neuen Termin vereinbart.`)
};

/**
* | output |
* | --- |
* | "The customer agreed on a new appointment with you." |
*
* @param {Cad_Modal_SubtitleInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cad_modal_subtitle = /** @type {((inputs?: Cad_Modal_SubtitleInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cad_Modal_SubtitleInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cad_modal_subtitle(inputs)
	if (locale === "ja") return ja_cad_modal_subtitle(inputs)
	if (locale === "fr") return fr_cad_modal_subtitle(inputs)
	return de_cad_modal_subtitle(inputs)
});